import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { finalize, map, Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Review, ReviewSaveData } from '../../_types/review.type';
import { GlobalLoaderService } from '../_core/global-loader.service';
import { ParkingsApiService } from './parkings-api.service';

@Injectable({
  providedIn: 'root',
})
export class ReviewsApiService {
  private _httpClient = inject(HttpClient);
  private _parkingsApiService = inject(ParkingsApiService);
  private _globalLoaderService = inject(GlobalLoaderService);

  getReviews(parkingPointId: number): Observable<Review[]> {
    this._globalLoaderService.show();
    return this._httpClient
      .get<Review[]>(`${environment.apiUrl}/parking-points/${parkingPointId}/reviews/`)
      .pipe(
        map((reviews: Review[]) =>
          reviews
            .map((review: Review) => new Review(review))
            .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime()),
        ),
        finalize(() => this._globalLoaderService.hide()),
      );
  }

  postReview(parkingPointId: number, body: ReviewSaveData) {
    this._globalLoaderService.show();
    return this._httpClient
      .post(`${environment.apiUrl}/parking-points/${parkingPointId}/reviews/`, body)
      .pipe(
        switchMap(() => this._parkingsApiService.getParking(parkingPointId)),
        finalize(() => this._globalLoaderService.hide()),
      );
  }

  putReview(parkingPointId: number, reviewId: number, body: ReviewSaveData) {
    this._globalLoaderService.show();
    return this._httpClient
      .put(`${environment.apiUrl}/parking-points/${parkingPointId}/reviews/${reviewId}/`, body)
      .pipe(
        switchMap(() => this._parkingsApiService.getParking(parkingPointId)),
        finalize(() => this._globalLoaderService.hide()),
      );
  }
}
